import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddIcon from "@mui/icons-material/Add";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { deleteBaseBrokeragePlan, getBaseBrokeragePlanDetails } from "../../Services/Brokerage";

import { getBaseBrokeragePlans } from "../../Services/Brokerage";

/* 🔥 IMPORT YOUR WIZARD */
import CreateBasicBrokerageWizard from "./CreateBasicBrokerageWizard";

const BasicBrokerageConfig = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);

  // 🔥 CONTROL VIEW
  const [viewMode, setViewMode] = useState("LIST");

  const handleViewPlan = async (planId) => {
    try {
      const data = await getBaseBrokeragePlanDetails(planId);
      setSelectedPlan(data);
      setOpenViewDialog(true);
    } catch (err) {
      console.error("View plan error", err);
    }
  };


  const handleDeletePlan = (id) => {
    setPlanToDelete(id);
    setDeleteDialogOpen(true);
  };

  const confirmDeletePlan = async () => {
    try {
      await deleteBaseBrokeragePlan(planToDelete);
      loadPlans();
    } catch (err) {
      console.error(err);
    }

    setDeleteDialogOpen(false);
    setPlanToDelete(null);
  };
  // LIST | CREATE

  const loadPlans = async () => {
    try {
      const data = await getBaseBrokeragePlans();
      setPlans(data || []);
    } catch (err) {
      console.error("Error fetching plans:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPlans();
  }, []);

  return (
    <Box p={1}>
      {/* HEADER */}
      {/* <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            backgroundColor: "#EEF4FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DescriptionOutlinedIcon sx={{ color: "#2563EB" }} />
        </Box>

        <Box>
          <Typography fontSize="20px" fontWeight={600}>
            Basic Brokerage Configuration
          </Typography>
          <Typography fontSize="14px" color="text.secondary">
            Define the base brokerage that applies to every agreement.
          </Typography>
        </Box>
      </Box> */}

      {/* ===================== */}
      {/* LIST VIEW */}
      {/* ===================== */}
      {viewMode === "LIST" && (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
          >
            <Typography fontSize="16px" fontWeight={600}>
              Active Base Brokerage Plans ({plans.length})
            </Typography>

            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: "#2563EB",
              }}
              onClick={() => setViewMode("CREATE")}
            >
              Create New Plan
            </Button>
          </Box>

          {/* PLANS LIST */}
          <Box
            sx={{
              maxHeight: "700px",
              overflowY: "auto",
              pr: 1,
            }}
          >
            <Box display="flex" flexDirection="column" gap={2}>
              {plans.map((plan, index) => {
                const description =
                  plan.calc_type === "percentage"
                    ? `Project Level • ${plan.value}%`
                    : `Project Level • ₹${plan.value}`;

                const validity =
                  plan.start_date && plan.end_date
                    ? `${plan.start_date} - ${plan.end_date}`
                    : "Always Active";

                return (
                  <Paper
                    key={plan.id || index}
                    elevation={0}
                    sx={{
                      borderRadius: "12px",
                      border: "1px solid #E5E7EB",
                      p: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box display="flex" gap={2} alignItems="center">
                      <Box
                        sx={{
                          width: 44,
                          height: 44,
                          borderRadius: "12px",
                          backgroundColor: "#EEF4FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DescriptionOutlinedIcon sx={{ color: "#2563EB" }} />
                      </Box>

                      <Box>
                        <Box display="flex" gap={1}>
                          <Typography fontWeight={600}>
                            {plan.name}
                          </Typography>

                          <Chip
                            label={plan.status}
                            size="small"
                            sx={{
                              backgroundColor: "#DCFCE7",
                              color: "#15803D",
                              fontWeight: 500,
                            }}
                          />


                        </Box>

                        <Typography fontSize="14px" color="text.secondary">
                          {description}
                        </Typography>

                        {plan.created_at && (
                          <Typography
                            fontSize="12px"
                            color="text.secondary"
                            mt={0.5}
                          >
                            Created: {plan.created_at}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gap={2}>

                      <Box display="flex" gap={1}>
                        <CalendarTodayOutlinedIcon
                          sx={{ fontSize: 16 }}
                        />


                        <Typography fontSize="13px">
                          {validity}
                        </Typography>
                      </Box>
                      <IconButton
                        size="small"
                        onClick={() => handleViewPlan(plan.id)}
                        sx={{
                          color: "#2563EB",
                          width: 32,
                          height: 32,
                        }}
                      >
                        <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={() => handleDeletePlan(plan.id)}
                        sx={{
                          color: "#DC2626",
                          width: 32,
                          height: 32,
                        }}
                      >
                        <DeleteOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Box>
                  </Paper>
                );
              })}
            </Box>
          </Box>
        </>
      )}

      {/* ===================== */}
      {/* CREATE WIZARD VIEW */}
      {/* ===================== */}
      {viewMode === "CREATE" && (
        <CreateBasicBrokerageWizard
          onCancel={() => setViewMode("LIST")}
          onSuccess={() => {
            loadPlans();        // refresh list
            setViewMode("LIST");
          }}
        />
      )}


      <Dialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Base Brokerage Plan</DialogTitle>

        <DialogContent dividers>
          {selectedPlan && (
            <Box display="flex" flexDirection="column" gap={3}>

              {/* 🔥 PLAN INFO IN 2-COLUMN GRID */}
              <Box
                display="grid"
                gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
                gap={2}
              >
                <Typography>
                  <b>Plan Name:</b> {selectedPlan.name}
                </Typography>

                <Typography>
                  <b>Calculation Type:</b> {selectedPlan.calc_type}
                </Typography>

                <Typography>
                  <b>Value:</b>{" "}
                  {selectedPlan.calc_type === "Percentage"
                    ? `${selectedPlan.value}%`
                    : `₹ ${Number(selectedPlan.value).toLocaleString("en-IN")}`}
                </Typography>

                <Typography>
                  <b>Validity Start:</b>{" "}
                  {selectedPlan.start_date
                    ? new Date(selectedPlan.start_date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    : "-"}
                </Typography>

                <Typography>
                  <b>Validity End:</b>{" "}
                  {selectedPlan.end_date
                    ? new Date(selectedPlan.end_date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    : "-"}
                </Typography>
              </Box>

              {/* 🔥 PROJECTS SECTION */}
              <Box>
                <Typography fontWeight={600} mb={1}>
                  Projects
                </Typography>

                {selectedPlan.base_brokerage_plan_projects?.length > 0 ? (
                  <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                    {selectedPlan.base_brokerage_plan_projects.map((p) => {
                      const projectName = p.Projects?.projectName || "Unknown Project";
                      const wingName = p.Wings?.wingName;

                      return (
                        <Chip
                          key={`${p.project_id}-${p.wing_id || "all"}`}
                          label={
                            wingName
                              ? `${projectName} - ${wingName}`   // ✅ project + wing
                              : projectName                     // ✅ only project
                          }
                          size="small"
                          sx={{
                            backgroundColor: "#F1F5F9",
                            fontWeight: 500,
                          }}
                        />
                      );
                    })}
                  </Box>
                ) : (
                  <Typography color="text.secondary">
                    Applies to all projects
                  </Typography>
                )}
              </Box>

            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Plan</DialogTitle>

        <DialogContent dividers>
          <Typography>
            Are you sure you want to delete this plan?
          </Typography>

          <Typography color="error" mt={1}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDeletePlan}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>


  );
};

export default BasicBrokerageConfig;
